document.addEventListener('DOMContentLoaded', () => {
  const containers = Array.from(document.getElementsByClassName('js-guest-picker'));

  containers.forEach((container) => {
    const inputWrapper = container.querySelector('.js-guest-picker-input-wrapper');
    const counter = container.querySelector('.js-guest-picker-counter');
    const quantities = container.querySelectorAll('.js-quantity');
    let total = 0;
    let documentClickHandler = null;

    const handleChange = () => {
      total = 0;
      quantities.forEach((quantitySelector) => {
        if (quantitySelector.quantity) {
          const value = quantitySelector.quantity.getValue();
          total += parseFloat(value, 10);
        }
      });

      counter.textContent = total;
    };

    quantities.forEach((quantitySelector) => {
      if (quantitySelector.quantity) {
        const value = quantitySelector.quantity.getValue();
        total += parseFloat(value, 10);
      }

      counter.textContent = total;

      quantitySelector.addEventListener('quantity:change', handleChange);
    });

    const toggle = (event) => {
      event.preventDefault();
      const isActive = container.classList.toggle('is-active');

      if (isActive) {
        documentClickHandler = (e) => {
          if (!container.contains(e.target)) {
            container.classList.remove('is-active');
            document.removeEventListener('click', documentClickHandler);
            documentClickHandler = null;
          }
        };
        document.addEventListener('click', documentClickHandler);
      } else if (documentClickHandler) {
        document.removeEventListener('click', documentClickHandler);
        documentClickHandler = null;
      }
    };

    inputWrapper.addEventListener('click', toggle);
  });
});
